import React, { useEffect, useState } from "react";
import NextPrev from "../../../Helpers/Components/NextPrev";
import { setBooking, setCustomerPhoto, setStep } from "../../../Reducer/bookingSlice";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import Handler from "../../../Helpers/Components/Handler";
import Compressor from 'compressorjs';
import White from "../../../Assets/images/white-bg.avif"
import Modal from "../../../Helpers/Components/Modal";
import Select from 'react-select'

const Booking = (props) => {
    const dispatch = useDispatch()
    const booking = useSelector(state => state?.booking?.booking)
    const [loading, setLoading] = useState(false)
    const [photoModal, setPhotoModal] = useState(false)
    const [chosen, setChosen] = useState()
    const [proof, setProof] = useState()
    const [other, setOther] = useState(false)
    const [approval, setApproval] = useState(true)
    const [approvalModal, setApprovalModal] = useState(false)
    const dlData = (booking?.customer?.kyc?.length ? booking?.customer?.kyc?.filter((element) => element?.type === "dl")?.length ? booking?.customer?.kyc?.filter((element) => element?.type === "dl")[0] : "-" : "-")
    const setSteps = () => {
        dispatch(setStep(3))
    }
    const checkFileSize = async (file, preview) => {
        if (file.size > 4.5 * 1024 * 1024) {
            toast.error('Compressed image size exceeds 4.5 MB.');
        } else {
            if (preview === "photo") {
                setLoading(true)
                const response = await Handler({ method: 'patch', url: `/customer/details/image/${booking?.customerId}`, data: { photo: file }, headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    toast.success(response?.message)
                    dispatch(setCustomerPhoto({ photo: response?.data }))
                    setPhotoModal(false)
                } else {
                    toast.error("Unable to upload photo")
                }
                setLoading(false)
            } else {
                setLoading(true)
                const response = await Handler({ method: 'patch', url: `/booking/details/form/photo/${props?.bookingId}`, data: { formPhoto: file }, headers: { 'Content-Type': 'multipart/form-data' } })
                if (response?.success) {
                    dispatch(setBooking({ formPhoto: response?.data }))
                } else {
                    toast.error("Unable to upload photo")
                }
                setLoading(false)
            }
        }
    };
    const handleChange = (e, name) => {
        if (e?.target?.checked) {
            const value = Array.isArray(booking?.proofCollected) ? booking.proofCollected : [];
            const updatedValue = [...value, name];
            dispatch(setBooking({ proofCollected: updatedValue }));
        } else {
            const value = Array.isArray(booking?.proofCollected) ? booking.proofCollected?.filter(element => element !== name) : [];
            const updatedValue = [...value];
            dispatch(setBooking({ proofCollected: updatedValue }));
        }

    }
    const handleOther = (checked, name) => {
        if (checked) {
            const value = Array.isArray(booking?.proofCollected) ? booking.proofCollected?.filter(element => element === "dl" || element === "aadhaar" || element === "passport" || element === "secDl" || element === "secAadhaar" || element === "secPassport" || element === "voter" || element === "familyCard") : [];
            const updatedValue = [...value, name];
            dispatch(setBooking({ proofCollected: updatedValue }));
        } else {
            const value = Array.isArray(booking?.proofCollected) ? booking.proofCollected?.filter(element => element === "dl" || element === "aadhaar" || element === "passport" || element === "secDl" || element === "secAadhaar" || element === "secPassport" || element === "voter" || element === "familyCard") : [];
            const updatedValue = [...value];
            dispatch(setBooking({ proofCollected: updatedValue }));
        }
    }
    const compressImage = (file, preview) => {
        new Compressor(file, {
            quality: 0.9,
            convertSize: 1 * 1024 * 1024,
            success(result) {
                checkFileSize(result, preview);
            },
            error(err) {
                toast.error(err.message);
            },
        });
    };
    const handleImage = (event, preview) => {
        if (event.target.files[0]) {
            compressImage(event.target.files[0], preview);
        }
    };
    const setPreview = () => {
        if (!booking?.proofCollected?.length) {
            toast.error("Proof collected is required")
        } else if (other && (booking?.proofCollected?.length ? !(booking?.proofCollected?.filter(element => element !== "dl" && element !== "aadhaar" && element !== "passport" && element !== "voter" && element !== "secDl" && element !== "secAadhaar" && element !== "secPassport" && element !== "familyCard")?.length) : false)) {
            toast.error("Proof Collected is empty")
        } else if (!props?.dl?.id || !props?.dl?.photo?.length) {
            toast.error("Please complete dl Data before booking")
        } else {
            if (booking?.customer?.photo) {
                if (!approval) {
                    props?.setPreview(true)
                } else {
                    setApprovalModal(true)
                }
            } else {
                setPhotoModal(true)
            }
        }
    }
    const getApproval = async () => {
        setLoading(true)
        const response = await Handler({ method: 'PATCH', url: `/booking/approval/${booking.bookingId}`, data: {} })
        if (response?.success) {
            setApproval(false)
            setApprovalModal(false)
        } else {
            toast.error(response?.message)
        }
        setLoading(false)
    }
    useEffect(() => {
        if (booking?.proofCollected?.length) {
            setOther(booking?.proofCollected?.filter((element) => element !== "dl" && element !== "aadhaar" && element !== "passport" && element !== "secDl" && element !== "secAadhaar" && element !== "secPassport" && element !== "voter" && element !== "familyCard")?.length)
        }
    }, [booking?.proofCollected])
    useEffect(() => {
        let totalAmount =
            ((Number(booking?.rentalFee || 0) -
                Number(booking?.offerPerDay || 0)) * (booking?.totalDays || 0)) +
            Number(booking?.deliveryDetails?.price || 0) + Number(booking?.pickupDetails?.price || 0) +
            Number(booking?.securityDeposit || 0)
        totalAmount += Number(booking?.point) === 0.5 ? (Number(booking?.rentalFee || 0) / 2) - Number(booking?.halfDayOffer || 0) : 0
        dispatch(setBooking({ balancePaid: totalAmount - Number(booking?.advance?.amount || 0), totalAmount }));
    }, [booking?.rentalFee, booking?.offerPerDay, booking?.totalDays, booking?.deliveryDetails, booking?.pickupDetails, booking?.securityDeposit, booking?.point, booking?.halfDayOffer, booking?.advance, booking?.balance]);
    return (
        <React.Fragment>
            <div className="row my-3">
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="leadMode" className="form-label">Lead Mode </label>
                        <input readOnly name="leadMode" id="leadMode" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(booking?.lead?.mode || "")} />
                    </div>
                </div>
                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="staff" className="form-label">Lead Attended By </label>
                        <input readOnly name="staff" id="staff" autoComplete="off" disabled className="form-control input-theme text-uppercase" value={(booking?.lead?.name || booking?.lead?.staffId || "")} />
                    </div>
                </div>
               {/*  <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="bookBy" className="form-label">Booking Given By </label>
                        <Select
                            styles={{
                                control: (base, state) => ({
                                    ...base,
                                    borderColor: state.isFocused ? "#f16436" : base.borderColor,
                                    boxShadow: state.isFocused ? "0 0 0 1px #f16436" : "none",
                                    "&:hover": {
                                        borderColor: "#f16436"
                                    }
                                }),
                                option: (style, state) => ({
                                    ...style,
                                    backgroundColor: state.isSelected
                                        ? "#f16436"
                                        : (state.isFocused || state.isActive)
                                            ? "#f164361a"
                                            : "white",
                                    color: state.isSelected ? "white" : "black"
                                })
                            }}
                            onChange={(e) => { dispatch(setBooking({ deliveryBy: e.value })) }} value={props?.leadList?.length && booking.deliveryBy ? (props?.leadList?.find(element => element.value === booking?.deliveryBy) || "") : ""} options={props.leadList} />
                    </div>
                </div>*/}
            </div>
            <div className="row">

                <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                    <div className="mb-3">
                        <label htmlFor="formPhoto" className="form-label"> Form Photo </label>
                        <div className="main-div">
                            <div className="btn-div">{loading ? "" : <label htmlFor="formPhoto" className="me-2 upload-btn">Upload</label>}
                                <button className="btn-warning btn btn-sm" onClick={() => { if (booking?.formPhoto) { setChosen(booking?.formPhoto); setProof(true) } }}>View</button>
                            </div>
                            <input type="file" accept="image/*" className="d-none" name="formPhoto" disabled={loading} id="formPhoto" onChange={(e) => { handleImage(e, "formPhoto") }} />
                            <img src={booking?.formPhoto || White} alt="Form" className="kycPhotoImg" />
                        </div>
                    </div>
                </div>

            </div>
            <div className="my-3">
                <label htmlFor="proofCollected" className="form-label">Proof Collected </label>
                <div className="d-flex flex-wrap gap-3">
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="drivingLicense" onChange={(e) => { handleChange(e, "dl") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "dl")?.length : false} />
                        <label className="form-check-label" htmlFor="drivingLicense"> Driving License </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="aadhaar" onChange={(e) => { handleChange(e, "aadhaar") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "aadhaar")?.length : false} />
                        <label className="form-check-label" htmlFor="aadhaar"> Aadhaar </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="passport" onChange={(e) => { handleChange(e, "passport") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "passport")?.length : false} />
                        <label className="form-check-label" htmlFor="passport"> Passport </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="voterId" onChange={(e) => { handleChange(e, "voter") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "voter")?.length : false} />
                        <label className="form-check-label" htmlFor="voterId"> Voter ID </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="familyCard" onChange={(e) => { handleChange(e, "familyCard") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "familyCard")?.length : false} />
                        <label className="form-check-label" htmlFor="familyCard"> Family Card </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="other" onChange={(e) => { if (e.target.checked) { setOther(true) } else { setOther(false); handleOther(false) } }} checked={other} />
                        <label className="form-check-label" htmlFor="other"> Other </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" id="secDrivingLicense" onChange={(e) => { handleChange(e, "secDl") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "secDl")?.length : false} />
                        <label className="form-check-label" htmlFor="secDrivingLicense">Co-Pass Driving License </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="secAadhaar" onChange={(e) => { handleChange(e, "secAadhaar") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "secAadhaar")?.length : false} />
                        <label className="form-check-label" htmlFor="secAadhaar">Co-Pass Aadhaar </label>
                    </div>
                    <div className="form-check">
                        <input className="form-check-input" type="checkbox" value="" id="secPassport" onChange={(e) => { handleChange(e, "secPassport") }} checked={booking?.proofCollected?.length ? booking?.proofCollected?.filter(element => element === "secPassport")?.length : false} />
                        <label className="form-check-label" htmlFor="secPassport">Co-Pass Passport </label>
                    </div>
                </div>
            </div>
            {
                other ?
                    <div className="row">
                        <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                            <div className="my-3">
                                <label htmlFor="proofCollected" className="form-label">Proof Collected </label>
                                <input onChange={(e) => { handleOther(true, e.target.value) }} name="proofCollected" id="location" autoComplete="off" disabled={loading} className="form-control input-theme text-uppercase" value={booking?.proofCollected?.length ? (booking?.proofCollected?.filter((element) => element !== "dl" && element !== "aadhaar" && element !== "passport" && element !== "secDl" && element !== "secAadhaar" && element !== "secPassport" && element !== "voter" && element !== "familyCard")?.length ? booking?.proofCollected?.filter((element) => element !== "dl" && element !== "aadhaar" && element !== "secDl" && element !== "secAadhaar" && element !== "secPassport" && element !== "passport" && element !== "voter" && element !== "familyCard")[0] : "") : ""} />
                            </div>
                        </div>
                    </div>
                    : ""
            }
            <NextPrev step={4} setStep={setSteps} last={3} loading={loading} />
            <div className="text-center mt-4"><button className="btn btn-theme" disabled={loading} onClick={() => { setPreview() }}>{loading ? <i className="fa-solid fa-spinner fa-spin"></i> : "Preview"}</button></div>
            <Modal header="Profile Photo" size={'lg'} onShow={photoModal} footerClassname={'justify-content-center'} toggle={() => setPhotoModal(false)} overlayToggle={() => setPhotoModal(false)}>
                <div className="row justify-content-center align-items-center">
                    <div className="col-md-6 col-xl-4 mt-3 mt-md-0">
                        <div className="mb-3">
                            <label htmlFor="photo" className="form-label"> Profile Photo </label>
                            <div className="main-div">
                                <div className="btn-div">{loading ? "" : <label htmlFor="photo" className="me-2 upload-btn">Upload</label>}</div>
                                <input type="file" accept="image/*" className="d-none" name="photo" disabled={loading} id="photo" onChange={(e) => { handleImage(e, "photo") }} />
                                <img src={booking?.customer?.photo || White} alt="Form" className="kycPhotoImg" />
                            </div>
                        </div>
                    </div>
                </div>
            </Modal>
            <Modal header="Photo" onShow={proof} toggle={() => setProof(false)} overlayToggle={() => setProof(false)}>
                <div className="modalPhoto">
                    <img src={chosen || White} alt="Proof" />
                </div>
            </Modal>
            <Modal header="Approval" size={'xl'} onShow={approvalModal} toggle={() => setApprovalModal(false)} overlayToggle={() => setApprovalModal(false)}>
                <div className="px-4">
                    <div className="mb-3 fw-medium">Are you sure you want to deliver the car to this person? </div>
                    <div className="row">
                        <div className="col-lg-6">
                            <label className="fs-5 text-underline fw-medium mb-3">Passenger: </label>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">DL Details:</label>
                                <label className={`${booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "dl" && element.id) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "dl" && element.id) ? "Exists" : "Not Found"}</label>
                            </div>
                            {
                                dlData?.detail?.validTo ?
                                    <div className="mb-3 row align-items-center">
                                        <label className="fw-medium text-capitalize col-6">DL Valid Upto:</label>
                                        <label className={`fw-medium text-capitalize col-6`}>{dlData?.detail?.addresses && dlData?.detail?.validTo ? (new Date(dlData?.detail?.validTo) < new Date() ? <span className="text-danger fw-bold">Expired</span> : dlData?.detail?.validTo) : (dlData?.detail?.validTo && dlData?.detail?.validTo?.split("/")?.length && new Date(dlData?.detail?.validTo?.split("/")[2], dlData?.detail?.validTo?.split("/")[1] - 1, dlData?.detail?.validTo?.split("/")[0]) < new Date() ? <span className="text-danger fw-bold">Expired</span> : dlData?.detail?.validTo)}</label>
                                    </div>
                                    : ""
                            }
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">DL Photos:</label>
                                <label className={`${booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "dl" && element.photo?.length) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "dl" && element.photo?.length) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Aadhaar Details:</label>
                                <label className={`${booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "aadhaar" && element.id) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "aadhaar" && element.id) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Aadhaar Photos:</label>
                                <label className={`${booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "aadhaar" && element.photo?.length) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "aadhaar" && element.photo?.length) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Passport Details:</label>
                                <label className={`${booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "passport" && element.id) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "passport" && element.id) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Passport Photos:</label>
                                <label className={`${booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "passport" && element.photo?.length) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.kyc?.length && booking?.customer?.kyc?.find(element => element.type === "passport" && element.photo?.length) ? "Exists" : "Not Found"}</label>
                            </div>

                        </div>
                        <div className="col-lg-6">

                            <div className="mb-3 row align-items-center"> <label className="fs-5 text-underline fw-medium"> Co-Passenger: </label><label className="col-5"></label> </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">DL Details:</label>
                                <label className={`${booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "dl" && element.id) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "dl" && element.id) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">DL Photos:</label>
                                <label className={`${booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "dl" && element.photo?.length) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "dl" && element.photo?.length) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Aadhaar Details:</label>
                                <label className={`${booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "aadhaar" && element.id) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "aadhaar" && element.id) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Aadhaar Photos:</label>
                                <label className={`${booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "aadhaar" && element.photo?.length) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "aadhaar" && element.photo?.length) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Passport Details:</label>
                                <label className={`${booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "passport" && element.id) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "passport" && element.id) ? "Exists" : "Not Found"}</label>
                            </div>
                            <div className="mb-3 row align-items-center">
                                <label className="fw-medium text-capitalize col-6">Passport Photos:</label>
                                <label className={`${booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "passport" && element.photo?.length) ? "" : "text-red"} fw-medium text-capitalize col-6`}>{booking?.customer?.otherKyc?.length && booking?.customer?.otherKyc?.find(element => element.type === "passport" && element.photo?.length) ? "Exists" : "Not Found"}</label>
                            </div>
                        </div>
                    </div>
                    <div className="text-center mt-4">
                        <button className="btn btn-success" disabled={loading} onClick={getApproval}>Yes</button>
                        <button className="btn btn-danger ms-2" disabled={loading} onClick={() => setApprovalModal(false)}>No</button>
                    </div>
                </div>
            </Modal>
        </React.Fragment>
    )
}

export default Booking;